<div class="modal fade show" id="cycle-count-upload-detail-modal" tabindex="-1" aria-labelledby="cycle-count-upload-detail-modalLabel"
    aria-hidden="true" [ngClass]="{'expanded': isExpanded}" [ngStyle]="{'display': 'block'}">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <app-popup-header
                [isExpanded]="isExpanded"
                [title]="'Cycle Count Warehouses with Open Exceptions'"
                [hideCreationDate]="true"
                (onClose)="close()"
                (onExpandCollapse)="isExpanded = $event"
            ></app-popup-header>
            <div class="modal-body cycle-count-popup-body">
                <inavista-grid #cycleCountExceptionPopupGrid
                    [config]="gridConfig"
                    [actionIcons]="actionIcons"
                    (actionIconClick)="onActionIconClick($event)"
                    (hyperlinkClick)="onHyperlinkClick($event)"
                    (exportRequested)="onExportRequested()" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>

@if (cycleCountId(); as id) {
<app-cycle-counts-popup
    [showComments]="false"
    [cycleCountId]="id"
    [tab]="'details'"
    (onClose)="cycleCountId.set(null)"
></app-cycle-counts-popup>
}
